<div mat-dialog-title>
    <h1>{{ data.name }}</h1>
    <button mat-button
            mat-dialog-close
            [attr.aria-label]="'generic.close' | translate"
            [matTooltip]="'generic.close' | translate">
        <mat-icon svgIcon="close"></mat-icon>
    </button>
</div>
<mat-dialog-content>
    <div class="media">
        <img [src]="data.badge" alt=""/>
        <dl role="list">
            <dt role="listitem">{{ 'openbadge.name' | translate }}</dt>
            <dd role="listitem" class="subtitle">{{ data.name }}</dd>
            <dt role="listitem">{{ 'openbadge.issuer' | translate }}</dt>
            <dd role="listitem" class="subtitle">{{ 'openbadge.issuer-value' | translate }}</dd>
        </dl>
        <button
            mat-raised-button
            cdkFocusInitial
            class="mat-accent"
            (click)="downloadBadgeImage()">
            {{ 'generic.download' | translate }}
        </button>
        <br>
        <button
            mat-raised-button
            cdkFocusInitial
            class="mat-accent"
            (click)="downloadBadgeCertificate()">
            {{ 'generic.download_certificate' | translate }}
        </button>
    </div>
    <div class="data">
        <dl role="list">
            <dt role="listitem">{{ 'openbadge.award-username' | translate }}</dt>
            <dd role="listitem" class="subtitle">{{ data.awardDetails.username }}</dd>
            <dt role="listitem">{{ 'openbadge.award-issueDate' | translate }}</dt>
            <dd role="listitem" class="subtitle">{{ data.awardDetails.issueDate }}</dd>
            <dt role="listitem">{{ 'openbadge.description' | translate }}</dt>
            <dd role="listitem"><p>{{ data.description }}</p></dd>
            <dt role="listitem">{{ 'openbadge.criteria' | translate }}</dt>
            <dd role="listitem"><p>{{ data.criteria }}</p></dd>
        </dl>

    </div>
</mat-dialog-content>
<mat-dialog-actions *ngIf="!isGar" align="end" >
    <div></div>
    <ul >
        <li>
            <mat-icon svgIcon="mail"></mat-icon>
            <a [href]="'openbadge.link1-href' | translate" target="_blank">{{ 'openbadge.link1-text' | translate}}
                <mat-icon svgIcon="arrow_diag"></mat-icon>
            </a>
        </li>
        <li>
            <mat-icon svgIcon="world"></mat-icon>
            <a target="_blank" [href]="'openbadge.link2-href' | translate">{{ 'openbadge.link2-text' | translate}}
                <mat-icon svgIcon="arrow_diag"></mat-icon>
            </a>
        </li>
        <li>
            <mat-icon svgIcon="information"></mat-icon>
            <a target="_blank" [href]="'openbadge.link3-href' | translate">{{ 'openbadge.link3-text' | translate}}
                <mat-icon svgIcon="arrow_diag"></mat-icon>
            </a>
        </li>
    </ul>
    <div></div>
</mat-dialog-actions>